import { useContext } from "react";
import { contextTheme } from "../contexts/ProviderTheme";
import { contextWeb3 } from "../contexts/ProviderWeb3";
import BubleCart from "./BubleCart";
import { cutAddress } from "../helpers/";
import CartDetails from "./CartDetails";
import { STORE_TOKEN } from "../helpers";

const styles = {
  top: "10px",
  left: "0px",
  position: "absolute",
  address: {
    padding: "5px",
    border: "1px solid #edf7f7",
    borderRadius: "15px",
    backgroundColor: "#f5ffff",
    color: "#333",
  },
  detalleCarrito: {},
};

export default function WrapperTop({ carrito, isVisible, toggleIsVisible }) {
  const { theme } = useContext(contextTheme);
  const { currentAccount, balanceStore, connectWalletHandler, logOut } =
    useContext(contextWeb3);

  const style = {
    color: !theme ? "#333" : "#FFF",
  };

  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className="">
        Connect Wallet
      </button>
    );
  };

  const cantidad = carrito.reduce((acum, x) => {
    return acum + x.cantidad;
  }, 0);

  const handleAddTokenToMetamask = async () => {
    const tokenAddress = STORE_TOKEN;
    const tokenSymbol = "STORE";
    const tokenDecimals = 18;
    const tokenImage = "";

    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20", // Initially only supports ERC20, but eventually more!
          options: {
            address: tokenAddress, // The address that the token is at.
            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals, // The number of decimals in the token
            image: tokenImage, // A string url of the token logo
          },
        },
      });

      if (wasAdded) {
        console.log("Thanks for your interest!");
      } else {
        console.log("Your loss!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>

      <div className="wrapper-top">
        <div className="link-menu-movil" onClick={()=>{document.querySelector('.nav-menu').classList.toggle('show');}}>
          <i className="fas fa-bars"></i>
        </div>
        <div className="search">
          <a rel="noreferrer" target="_blank" href="https://api.whatsapp.com/send?phone=+584128256644&amp;text=Hola%2C%20deseo%20realizar%20una%20consulta%20de%20una%20dApp" style={style}>
            <i className="fab fa-whatsapp"></i> <span>+58 412 8256644</span>
          </a>{" "}
          /{" "}
          <a rel="noreferrer" href="/" style={style}>
            <i className="fas fa-envelope"></i>{" "}
            <span>contacto@ecommerce-store.com</span>
          </a>
        </div>

        <div style={styles.address}>
          {currentAccount != null ? (
            <>
              {cutAddress(currentAccount)} <i className="fas fa-wallet"></i>{" "}
              {Number(balanceStore).toFixed(2)}{" "}
              <a
                onClick={handleAddTokenToMetamask}
                style={{ cursor: "pointer" }}
                title="Agregar Store a metamask"
              >
                $store
              </a>
              &nbsp;&nbsp;
              <a onClick={logOut} style={{cursor:"pointer", fontSize:"12px"}}>Cerrar sesi&oacute;n</a>
            </>
          ) : (
            connectWalletButton()
          )}
        </div>
        <div className="cart-icon">
          <button
            style={style}
            onClick={() => (carrito.length > 0 ? toggleIsVisible() : null)}
          >
            <span style={styles}>
              {carrito.length > 0 ? <BubleCart value={cantidad} /> : null}
            </span>
            <i className="fas fa-shopping-cart"></i>
          </button>
        </div>
      </div>
      {isVisible ? (
        <CartDetails toggleIsVisible={toggleIsVisible} carrito={carrito} />
      ) : null}
    </>
  );
}
